export const ROOT_LAWYERS_PAGE_URL: string = '/klienty-yuristu/';
export const ROOT_CATALOG_URL: string = '/juristes-advocates/';
export const ROOT_JOURNAL_URL: string = '/journal/';
export const ROOT_EDITORS_STAFF_URL: string = '/redakciya/';
export const ROOT_HELPER_URL: string = '/helper/';
export const ROOT_POLICIES_PAGE: string = '/legal/';
export const ROOT_PARTNER_PROGRAM_URL: string = 'https://gainnet.ru/affiliate-program';
export const PRIVACY_POLICY_URL: string = '/legal/privacy-policy/';
export const TERMS_OF_USE_URL: string = '/legal/terms/';
export const COMMON_PERSONAL_DATA_PROCESSING_URL: string = '/legal/consent-form-1/';
export const CALLBACK_PERSONAL_DATA_PROCESSING_URL: string = '/legal/consent-form-2/';
export const OFFER_POLICY_URL: string = '/legal/offer/';
export const CONSENT_DISTRIBUTION_URL: string = '/legal/consent-distribution/';
export const RECORDS_PRICES_URL: string = '/prices.pdf';

export const SHARE_WHATSAPP_URL: string = 'https://api.whatsapp.com/send?text=';
export const SHARE_TELEGRAM_URL: string = 'https://telegram.me/share/url?url=';
export const SHARE_VK_URL: string = 'https://vk.com/share.php?url=';
export const SHARE_OK_URL: string = 'https://connect.ok.ru/offer?url=';
